var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-manager"},[_c('div',{staticClass:"title-top bg-f mb-5"},[_vm._v("\n        佣金明细\n    ")]),_vm._v(" "),_c('commissionDetailStoreSelf')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }